import {getPropertyList} from "../../../property/api/get_property_list";
import {getRecommendedProperties} from "../../../property/api/get_recommended_properties";
import {propertyListConstraints} from "../../../property/constants/property_list_constraints";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {IAppDispatch} from "../../../store/store";
import {IApplicationOriginalProperty} from "../../types/IApplicationOriginalProperty";

interface IFetchVendorRecommendationsParams {
    excludedOfferIds: number[];
    radius: number;
    offerId?: number | null;
    originalApplicationProperty?: IPropertyDetailApplication | null;
    filters?: Record<string, string>;
}

export async function getVendorRecommendations(
    params: IFetchVendorRecommendationsParams,
    dispatch: IAppDispatch
): Promise<{
    results: IRecommendedProperty[];
    leadProperty: IApplicationOriginalProperty;
}> {
    const {originalApplicationProperty, offerId, filters = {}, excludedOfferIds, radius} = params;
    const pageSize = 12;

    const propertyId = originalApplicationProperty?.id;
    if (propertyId) {
        try {
            const recommendedProperties = await dispatch(
                getRecommendedProperties.initiate({propertyId, radius, page_size: pageSize, excludedOfferIds, ...filters})
            ).unwrap();
            return {
                results: recommendedProperties.results,
                leadProperty: originalApplicationProperty
            };
        } catch (_) {
            return {
                results: [],
                leadProperty: null
            };
        }
    }

    if (offerId) {
        const propertyListRes = await dispatch(getPropertyList.initiate({offer: offerId, ...propertyListConstraints})).unwrap();
        const firstProperty = propertyListRes.results[0];

        try {
            const recommendedPropertiesFromOffer = await dispatch(
                getRecommendedProperties.initiate({propertyId: firstProperty.id, radius, page_size: pageSize, excludedOfferIds, ...filters})
            ).unwrap();

            return {
                results: recommendedPropertiesFromOffer.results,
                leadProperty: firstProperty
            };
        } catch (_) {
            return {
                results: [],
                leadProperty: null
            };
        }
    }

    return {
        results: [],
        leadProperty: null
    };
}
import {getPropertyList} from "../../../property/api/get_property_list";
import {getRecommendedProperties} from "../../../property/api/get_recommended_properties";
import {propertyListConstraints} from "../../../property/constants/property_list_constraints";
import {IPropertyDetailApplication} from "../../../property/types/IPropertyDetailApplication";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {IAppDispatch} from "../../../store/store";
import {IApplicationOriginalProperty} from "../../types/IApplicationOriginalProperty";

interface IFetchVendorRecommendationsParams {
    excludedOfferIds: number[];
    radius: number;
    offerId?: number | null;
    originalApplicationProperty?: IPropertyDetailApplication | null;
    filters?: Record<string, string>;
}

export async function getVendorRecommendations(
    params: IFetchVendorRecommendationsParams,
    dispatch: IAppDispatch
): Promise<{
    results: IRecommendedProperty[];
    leadProperty: IApplicationOriginalProperty;
}> {
    const {originalApplicationProperty, offerId, filters = {}, excludedOfferIds, radius} = params;
    const pageSize = 12;

    const propertyId = originalApplicationProperty?.id;
    if (propertyId) {
        try {
            const recommendedProperties = await dispatch(
                getRecommendedProperties.initiate({propertyId, radius, page_size: pageSize, excludedOfferIds, ...filters})
            ).unwrap();
            return {
                results: recommendedProperties.results,
                leadProperty: originalApplicationProperty
            };
        } catch (_) {
            return {
                results: [],
                leadProperty: null
            };
        }
    }

    if (offerId) {
        const propertyListRes = await dispatch(getPropertyList.initiate({offer: offerId, ...propertyListConstraints})).unwrap();
        const firstProperty = propertyListRes.results[0];

        try {
            const recommendedPropertiesFromOffer = await dispatch(
                getRecommendedProperties.initiate({propertyId: firstProperty.id, radius, page_size: pageSize, excludedOfferIds, ...filters})
            ).unwrap();

            return {
                results: recommendedPropertiesFromOffer.results,
                leadProperty: firstProperty
            };
        } catch (_) {
            return {
                results: [],
                leadProperty: null
            };
        }
    }

    return {
        results: [],
        leadProperty: null
    };
}
